import React, { useState } from "react";
import '../../assets/css/donordashboard/MasterLayout.css'
import DonorSideBar from "../../screens/donordashboard/DonorSideBar";
import DonorTopBar from "../../screens/donordashboard/DonorTopBar";

const MasterLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="receiver-master-layout">

      {/* Sidebar */}
      <div className={`receiver-sidebar-wrapper ${sidebarOpen ? 'open' : ''}`}>
        <DonorSideBar onMenuToggle={toggleSidebar} />
      </div>

      {/* Main Content Area */}
      <div className="receiver-main-content">

        {/* Top Bar */}
        <DonorTopBar onMenuToggle={toggleSidebar} />

        {/* Page Content */}
        <div className="receiver-content-area">
          {children}
        </div>

      </div>

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div
          className="receiver-sidebar-overlay"
          onClick={toggleSidebar}
        ></div>
      )}

    </div>
  );
};

export default MasterLayout;